import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/common/Dialog'
import { SpeechContentType } from './types'
import useSpeechDialogStore from './speech-dialog.store.ts'
import MediaLibrary from './MediaLibrary'

const SpeechDialogLibrary: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useTranslation()
  const {
    setContentType,
    selectedLibraryFiles,
    setSelectedLibraryFiles,
    addLibraryAudioFiles,
  } = useSpeechDialogStore()
  const title = t('ls_generic_add_speech_audio_library')
  return (
    <>
      <Dialog.Header onClose={onClose}>
        <span className="text-[16px] font-semibold">{title}</span>
      </Dialog.Header>
      <div className="flex flex-1 flex-row">
        <MediaLibrary />
      </div>
      <Dialog.Footer
        confirmButton={
          <button
            type="button"
            className="min-w-[80px] rounded bg-zinc-700 px-4 py-2 text-sm font-semibold text-white hover:bg-zinc-600"
            onClick={() => {
              addLibraryAudioFiles(selectedLibraryFiles)
              setSelectedLibraryFiles([])
              setContentType(SpeechContentType.Main)
            }}
          >
            {t('ls_generic_open')}
          </button>
        }
      >
        <div className="flex w-full flex-row justify-end">
          <button
            type="button"
            className="min-w-[80px] rounded bg-zinc-700 px-4 py-2 text-sm font-semibold text-white hover:bg-zinc-600"
            onClick={() => {
              setSelectedLibraryFiles([])
              setContentType(SpeechContentType.Main)
            }}
          >
            {t('ls_generic_back')}
          </button>
        </div>
      </Dialog.Footer>
    </>
  )
}

export default SpeechDialogLibrary
